module.exports = "/_next/static/resources/art2-e96652c8e2ecf23b84a5e21880942b2e.webp";